// extracted by mini-css-extract-plugin
export default {"fr-view":"Tabs_fr-view__cK3SL","tab-list":"Tabs_tab-list__sWfgW","tab-list-item":"Tabs_tab-list-item__UQvK5","isActive":"Tabs_isActive__5EcN3"};